import React from 'react';
import { LEADS_TAB_MINE } from '../../tabs';
import MyLeads from './MyLeads';

function LeadsContent(props) {
    const { eventId, tab } = props;

    if (tab === LEADS_TAB_MINE) return <MyLeads eventId={eventId} />;

    return null;
}

export default LeadsContent;
